<template>
    <div class="bg-canicross">

        <header class="banner-carrera py-5">
            <div class="container text-center">
                <div
                    class="d-inline-block px-3 py-1 bg-dark text-white rounded-pill mb-3 letter-spacing-2 fw-bold small">
                    EDICIÓN 2026
                </div>

                <div class="header-content">
                    <h4 class="subtext-xhidenxi text-uppercase mb-0">XHIDENXI</h4>
                    <p class="text-muted small letter-spacing-2 mb-4">RETO ENTRE SENDEROS</p>

                    <h1 class="text-canicross display-1 fw-black text-dark mb-0">
                        canicross <span class="paw-icon">🐾</span>
                    </h1>

                    <h3 class="banner-tagline mt-2 fw-bold">ELIGE TU RETO</h3>

                    <div class="divider-xhidenxi mx-auto my-4"></div>

                    <div class="d-flex justify-content-center align-items-center gap-3">
                        <span class="banner-date fw-black fs-4">MAY 24, 2026</span>
                        <span class="text-muted fs-4">|</span>
                        <span class="banner-location fw-bold fs-5 text-uppercase">Canalejas</span>
                    </div>
                </div>
            </div>

        </header>

        <!-- Card Info -->
        <CardRaceInfo id="informacion"
            titulo="Canicross🐾 -</br> 5KM Entre Senderos"
            estado="Estado de México" color-estado="#000"
            fecha="Domingo 24 de mayo de 2026"
            sede="Canalejas, Jilotepec"
            hora="7:30 am"
            distancia="5 Km"
            :banner="bannerCarrera"
            :action-click="irARegistro"
            :inscripcion-cerrada="inscripcionesCerradas"
        />

        <!-- Información general -->
         <section class="info-section py-5">
            <div class="container">
                <div class="text-center mb-5">
                    <img src="@/assets/images/logo_principal.png" class="imgBanner img-fluid" alt="Mapa Bioparque">
                </div>

                <div class="row g-4 justify-content-center">
                    <div class="col-md-10 col-lg-8">
                        <div class="card-info-glass p-4 text-center">
                            <p class="fs-5 mb-0">
                                Prepárate para vivir una experiencia única en la ruta hacia el <strong>Cerro
                                    Xhidenxhi</strong> 🌄.
                                Corre, trota o camina con tu perro o reta tus límites en la 5K atlética.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Información de horarios -->
        <section class="logistics-grid py-5 bg-dark text-white rounded-5 mx-2">
            <div class="container">
                <div class="row text-center align-items-center">
                    <div class="col-md-4 border-end-custom ">
                        <i class="bi bi-geo-alt fs-1 text-lime"></i>
                        <h4 class="fw-black mt-3">SALIDA</h4>
                        <p class="mb-1">Explanada de la Delegación de Canalejas</p>

                        <a href="https://maps.app.goo.gl/5r5TsUMiPY8dL7697" target="_blank" class="btn btn-how-to-get d-inline-flex align-items-center gap-2 mb-4 mb-lg-0">
                            <i class="bi bi-cursor-fill"></i>
                            <span>CÓMO LLEGAR</span>
                        </a>
                    </div>
                    <div class="col-md-4 border-end-custom py-4 py-md-0 mb-4 mb-lg-0">
                        <i class="bi bi-clock-history fs-1 text-lime"></i>
                        <h4 class="fw-black mt-3">HORARIOS</h4>
                        <p class="mb-0"><strong>🐾 Canicross:</strong> 7:30 AM</p>
                        <p class="mb-0"><strong>🏃 Atlética 5K:</strong> 8:30 AM</p>
                    </div>
                    <div class="col-md-4">
                        <i class="bi bi-map fs-1 text-lime"></i>
                        <h4 class="fw-black mt-3">DISTANCIA</h4>
                        <p class="mb-0 fs-3 fw-black">5 KILÓMETROS</p>
                        <p class="small text-uppercase">Ruta entre senderos 🌲</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Información de categorias y reglamento -->
        <section class="categories-section py-5">
            <div class="container">
                <div class="row g-5">
                    <div class="col-lg-6">
                        <div class="category-card p-4 h-100 border-xhidenxi">
                            <h2 class="fw-black mb-4">🐾 CANICROSS</h2>
                            <div class="pricing-badge mb-4">
                                <div class="row">
                                    <div class="col-6">
                                        <span class="small d-block">PREVENTA (Primeros 100)</span>
                                        <span class="fs-2 fw-black text-dark">$350 MXN</span>
                                    </div>

                                    <div class="col-6">
                                        <span class="small d-block">PRECIO GENERAL</span>
                                        <span class="fs-2 fw-black text-dark">$450 MXN</span>
                                    </div>
                                </div>
                            </div>

                            <h5 class="fw-black text-uppercase small mb-3">⚠️ REGLAMENTO DE SEGURIDAD</h5>
                            <ul class="list-unstyled custom-list">
                                <li><i class="bi bi-check-circle-fill text-success"></i> Uso obligatorio de pechera
                                    (arnés) todo el evento.</li>
                                <li><i class="bi bi-x-circle-fill text-danger"></i> Prohibido llevar al perro del
                                    collar.</li>
                                <li><i class="bi bi-check-circle-fill text-success"></i> Si tu mascota es reactiva,
                                    asegúrate de tener un buen control sobre tu mascota para evitar accidentes.</li>

                                <li class="text-center"><strong>Recuerda:</strong> Que la seguridad y el bienestar de tu mascota es solo tuya.</li>

                                <li class="mt-3 text-muted small"><strong>RAZAS RECOMENDADAS:</strong> Perros de
                                    trabajo/alta energía (Pastor Alemán, Belga, Husky).</li>
                                <li class="text-danger small"><strong>NO APTO:</strong> Razas braquicéfalas (Pug,
                                    Bulldog, etc).</li>
                            </ul>

                            <h5 class="fw-black text-center small mb-1">IMPORTANTE: Puedes correr, trotar o caminar con tu perro (La seguridad y bienestar del animal es prioridad)</h5>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="category-card p-4 h-100 border-xhidenxi bg-light">
                            <h2 class="fw-black mb-4">🏃‍♂️ ATLÉTICA 5K</h2>
                            <div class="pricing-badge mb-4">
                                <span class="small d-block">INSCRIPCIÓN GENERAL</span>
                                <span class="fs-2 fw-black text-dark">$400 MXN</span>
                            </div>
                            <p class="fs-5 mt-4">
                                Disfruta de una ruta técnica y escénica diseñada para retar tus marcas personales en un
                                entorno natural único.
                            </p>
                            <div class="mt-auto">
                                <span class="badge bg-dark p-2 w-100 mt-4 text-uppercase fw-bold">Cupo Limitado: 300
                                    Corredores</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Información de kits y su entrega -->
        <section class="kit-section py-5 bg-lime-soft">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <h3 class="text-center fw-black mb-4">TU INSCRIPCIÓN INCLUYE:</h3>
                        <div class="row g-3">
                            <div class="col-6">
                                <div class="kit-item shadow-sm">🎽 Playera Oficial</div>
                            </div>
                            <div class="col-6">
                                <div class="kit-item shadow-sm">🏅 Medalla Finalista</div>
                            </div>
                            <div class="col-6">
                                <div class="kit-item shadow-sm">🔢 Número de Corredor</div>
                            </div>
                            <div class="col-6">
                                <div class="kit-item shadow-sm">💧 Hidratación</div>
                            </div>
                            <div class="col-6">
                                <div class="kit-item shadow-sm">🍎 Snacks</div>
                            </div>
                            <div class="col-6">
                                <div class="kit-item shadow-sm">🗺️ Ruta Señalizada</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
                        <div
                            class="delivery-card p-4 bg-white shadow-sm rounded-4 border-start-black position-relative overflow-hidden">
                            <h4 class="fw-black mb-4 text-uppercase">Entrega de Kits</h4>

                            <div class="delivery-option mb-4">
                                <div class="d-flex align-items-center gap-2 mb-1">
                                    <i class="bi bi-calendar3 text-muted"></i>
                                    <strong class="text-uppercase">Sábado 23 de Mayo</strong>
                                </div>
                                <p class="mb-0 small ps-4">📍 Gimnasio El Terreno</p>
                                <p class="mb-0 small ps-4 text-muted">⏰ 8:00 AM a 5:00 PM</p>
                            </div>

                            <div class="divider-dashed my-3"></div>

                            <div class="delivery-option-event bg-lime-soft p-3 rounded-3 border-lime">
                                <div class="d-flex align-items-center gap-2 mb-1">
                                    <span class="badge-event">DÍA DEL EVENTO</span>
                                    <strong class="text-uppercase">Domingo 24 de Mayo</strong>
                                </div>
                                <p class="mb-0 small ps-1">📍 Explanada de la Delegación</p>
                                <p class="mb-0 small ps-1 fw-bold text-dark">⏰ 6:00 AM a 7:30 AM</p>
                            </div>
                        </div>

                        <div class="prize-card p-4 mt-3 bg-dark text-white rounded-4 shadow-lg border-bottom-lime">
                            <div class="d-flex align-items-center gap-3">
                                <i class="bi bi-trophy-fill fs-1 text-lime"></i>
                                <div>
                                    <h4 class="fw-black text-lime mb-0">$10,000 EN EFECTIVO</h4>
                                    <p class="small mb-0 text-uppercase letter-spacing-1">A repartir + Premios sorpresa
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Formas de inscripción -->
        <div class="container pb-5">
            <div class="text-center mt-5">
                <h4 class="text-xhidenxi fw-black mb-0">INSCRIPCIONES</h4>
                <p class="small text-muted text-uppercase letter-spacing-2">Elige tu método preferido</p>
            </div>

            <section class="mt-4 px-lg-0 px-3">
                <div class="row g-4 justify-content-center">

                    <div class="col-lg-4 col-md-6">
                        <div class="card-metodo-pago h-100 shadow-sm">
                            <div class="badge-tipo">PRESENCIAL</div>
                            <div class="text-center mb-4 mt-2">
                                <img src="@/assets/images/logo_principal.png" class="logo-presencial" alt="logo">
                            </div>
                            <div class="metodo-body text-center">
                                <h3 class="h5 fw-black mb-1">Gimnasio El Terreno</h3>
                                <p class="text-muted mb-2 small text-uppercase">Lunes a viernes</p>
                                <h5 class="fw-black text-dark bg-light py-2 rounded-3">5:00 PM a 8:00 PM</h5>
                                <p class="mt-3 small text-muted">Inscripción directa en el gimnasio.</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="card-metodo-pago h-100 highlight shadow">
                            <div class="badge-tipo bg-dark text-white">EN LÍNEA</div>
                            <div class="metodo-body">
                                <h3 class="h5 fw-black mb-3 text-center">Transferencia CLABE</h3>
                                <div class="clabe-box mb-3 border-dark">
                                    <code class="fs-6 text-dark fw-bold">728969000028945078</code>
                                </div>
                                <div class="row mb-3 px-2">
                                    <div class="col-6">
                                        <span class="label-pago">Banco</span>
                                        <p class="mb-0 fw-bold small">Spin por OXXO</p>
                                    </div>
                                    <div class="col-6 text-end">
                                        <span class="label-pago">Beneficiario</span>
                                        <p class="mb-0 fw-bold small">Gimnasio El Terreno</p>
                                    </div>
                                </div>
                                <div class="wa-notif p-3 rounded-3 text-center">
                                    <p class="small fw-bold mb-2">1. Inicia tu proceso de registro aquí:</p>
                                    <button class="btn btn-dark w-100 mb-3 py-2 fw-black shadow-sm" @click="irARegistro"
                                        :disabled="inscripcionesCerradas">
                                        {{ inscripcionesCerradas ? 'REGISTRO FINALIZADO' : 'INSCRIBIRME' }}
                                    </button>

                                    <p class="small text-muted mb-0">
                                        <strong>2.</strong> Una vez termiando, manda tu captura de la confirmación de
                                        registro y comprobante al
                                        <a href="https://wa.me/525540861907" class="text-confirmacion">
                                            <strong>55 4086 61907</strong>
                                        </a>
                                        para validar tu participación.
                                    </p>
                                </div>
                                <div class="action-box p-3 rounded-4 bg-light text-center">
                                    <p class="x-small text-muted mb-0">Sube tu comprobante al finalizar el registro.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="card-metodo-pago h-100 border-oxxo shadow-sm">
                            <div class="badge-tipo bg-oxxo text-white">EFECTIVO OXXO</div>
                            <div class="metodo-body">
                                <h3 class="h5 fw-black mb-3 text-center">Pago Directo en OXXO</h3>

                                <div class="card-number-box mb-3">
                                    <span class="label-pago text-center w-100 mb-1">Número para Deposito</span>
                                    <div
                                        class="d-flex justify-content-center align-items-center gap-2 py-2 bg-white rounded-3 border">
                                        <code class="fs-5 text-dark fw-black">2242 1704 2012 2648</code>
                                    </div>
                                </div>

                                <div class="instruction-step mb-3 d-flex gap-2 align-items-start">
                                    <div class="step-num">1</div>
                                    <p class="small mb-0">Realiza tu pago en caja y <strong>guarda tu ticket</strong>.
                                    </p>
                                </div>

                                <div class="instruction-step mb-4 d-flex gap-2 align-items-start">
                                    <div class="step-num">2</div>
                                    <p class="small mb-0">Inicia tu registro en el botón de abajo y <strong>carga la
                                            foto de tu ticket</strong>.</p>
                                </div>

                                <button class="btn btn-dark w-100 mb-3 py-2 fw-black shadow-sm" @click="irARegistro"
                                    :disabled="inscripcionesCerradas">
                                    {{ inscripcionesCerradas ? 'REGISTRO FINALIZADO' : 'INSCRIBIRME' }}
                                </button>

                                <div class="instruction-step mb-4 d-flex gap-2 align-items-start">
                                    <div class="step-num">3</div>
                                    <p class="small mb-0">
                                        Una vez termiando, manda tu captura de la confirmación de
                                        registro y comprobante al
                                        <a href="https://wa.me/525540861907" class="text-confirmacion">
                                            <strong>55 4086 61907</strong>
                                        </a>
                                        para validar tu participación.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import CardRaceInfo from '@/components/CardRaceInfo.vue'
import bannerCarrera from '@/assets/images/2026/bannerCanicross.jpeg'
import router from '@/router'

// eslint-disable-next-line no-unused-vars
const FECHA_LIMITE = new Date(2026, 4, 23, 23, 0, 0)
const ahora = ref(new Date())

const inscripcionesCerradas = computed(() => {
  return ahora.value >= FECHA_LIMITE
})

let timer
onMounted(() => {
  timer = setInterval(() => {
    ahora.value = new Date()
  }, 60000)
})

onUnmounted(() => {
  clearInterval(timer)
})

const irARegistro = () => {
  router.push('/registro-canicross-2026')
}
</script>

<style scoped>
@font-face {
    font-family: 'Dangrek';
    src: url('@/assets/fonts/Dangrek-Regular.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'FjallaOne';
    src: url('@/assets/fonts/FjallaOne-Regular.ttf') format('truetype');
    font-weight: normal;
}

.bg-canicross {
  background: linear-gradient(180deg, #e1f5d4 0%, #ffffff 100%);
  min-height: 100vh;
  padding: 2rem 0;
}

.subtext-xhidenxi {
    font-weight: 300;
    letter-spacing: 8px;
    font-size: 1.2rem;
    color: #000;
    margin-left: 8px;
}

.text-canicross {
    font-weight: 900;
    text-transform: lowercase;
    line-height: 0.8;
}

.paw-icon {
    font-size: 0.6em;
    vertical-align: middle;
}

.banner-tagline {
    letter-spacing: 3px;
    font-size: 1.1rem;
    color: #444;
}

.divider-xhidenxi {
    width: 50px;
    height: 4px;
    background-color: #000;
}

.imgBanner {
  display: block;
  margin: 0 auto;
  max-width: 180px;
}

.banner-date {
    color: #000;
}

.btn-how-to-get {
    background-color: #000;
    color: #fff;
    font-weight: 900;
    font-size: 0.75rem;
    padding: 10px 20px;
    border-radius: 50px;
    text-transform: uppercase;
    letter-spacing: 1px;
    border: 2px solid #000;
    transition: all 0.3s ease;
    text-decoration: none;
}

.btn-how-to-get:hover {
    background-color: #e1f5d4;
    color: #000;
    border-color: #e1f5d4;
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(225, 245, 212, 0.4);
}

.btn-how-to-get i {
    font-size: 0.9rem;
}

/* Efecto para el badge de Canalejas */
.banner-location {
    color: #666;
}

/* Ajuste móvil */
@media (max-width: 576px) {
    .text-canicross {
        font-size: 3.5rem;
    }
    .subtext-xhidenxi {
        letter-spacing: 4px;
        font-size: 1rem;
    }
}

.fw-black { font-weight: 900; }
.letter-spacing-2 { letter-spacing: 2px; }
.text-lime { color: #e1f5d4; }
.bg-lime-soft { background-color: #f9fbf8; }

.divider-center-black {
    width: 60px;
    height: 6px;
    background-color: #000;
    border-radius: 10px;
}

.card-info-glass {
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid #eee;
    border-radius: 20px;
}

.border-end-custom {
    border-right: 2px solid rgba(255,255,255,0.1);
}

.category-card {
    border-radius: 24px;
    transition: transform 0.3s ease;
}

.border-xhidenxi {
    border: 2px solid #000;
}

.border-start-black {
    border-left: 6px solid #000;
}

.kit-item {
    background: #fff;
    padding: 12px;
    border-radius: 12px;
    font-weight: 700;
    border: 1px solid #eee;
    text-align: center;
    font-size: 0.9rem;
}

.custom-list li {
    margin-bottom: 10px;
}

@media (max-width: 768px) {
    .border-end-custom { border-right: none; border-bottom: 1px solid rgba(255,255,255,0.1); }
}

.card-metodo-pago {
    background: #fff;
    border: 2px solid #f0f0f0;
    border-radius: 20px;
    padding: 30px 20px;
    position: relative;
    transition: all 0.3s ease;
}

.card-metodo-pago.highlight {
    border-color: #000;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.badge-tipo {
    position: absolute;
    top: -12px;
    left: 20px;
    background: #e1f5d4;
    color: #000;
    padding: 4px 15px;
    font-size: 0.7rem;
    font-weight: 900;
    border-radius: 50px;
    letter-spacing: 1px;
}

.logo-presencial {
    height: 60px;
    width: auto;
    object-fit: contain;
}

.clabe-box {
    background: #f8f8f8;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    border: 1px dashed #ccc;
}

.label-pago {
    font-size: 0.7rem;
    color: #888;
    text-transform: uppercase;
    display: block;
    font-weight: bold;
}

.wa-notif {
    background: #e1f5d4;
    border: 1px solid #d4eec3;
}

.metodo-body h3 {
    text-transform: uppercase;
    letter-spacing: -0.5px;
}

/* Efecto hover sutil */
.card-metodo-pago:hover {
    transform: translateY(-5px);
}

.border-start-black {
    border-left: 6px solid #000;
}

.divider-dashed {
    border-top: 1px dashed #ccc;
    width: 100%;
}

/* Badge especial para el día del evento */
.badge-event {
    background-color: #000;
    color: #e1f5d4; /* Verde lima */
    font-size: 0.65rem;
    font-weight: 900;
    padding: 4px 8px;
    border-radius: 4px;
    letter-spacing: 1px;
}

/* Contenedor resaltado para el día 24 */
.delivery-option-event {
    border: 1px solid #d4eec3;
    background-color: #f0f7eb;
}

.border-lime {
    border-color: #e1f5d4 !important;
}

.border-bottom-lime {
    border-bottom: 5px solid #e1f5d4;
}

.text-lime {
    color: #e1f5d4 !important;
}

.kit-item {
    transition: transform 0.2s;
    cursor: default;
}

.kit-item:hover {
    transform: translateY(-3px);
    border-color: #000;
}

.letter-spacing-1 {
    letter-spacing: 1px;
}

.bg-oxxo {
    background: #dd242c; /* Rojo OXXO pero elegante */
}

.border-oxxo {
    border: 2px solid #dd242c33 !important;
}

.border-oxxo-light {
    background-color: #fff5f5;
    border: 1px solid #ffeded;
}

.card-number-box {
    background-color: #fcfcfc;
    padding: 12px;
    border-radius: 12px;
}

/* Pasos de instrucción numéricos */
.step-num {
    background: #000;
    color: #fff;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7rem;
    font-weight: 900;
    flex-shrink: 0;
}

.x-small {
    font-size: 0.7rem;
}

.wa-notif-small {
    transition: all 0.3s ease;
}

.wa-notif-small:hover {
    background-color: #e1f5d4;
    transform: scale(1.02);
}

/* Ajuste para que las 3 cards se vean uniformes */
.metodo-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

@media (max-width: 991px) {
    .card-metodo-pago {
        margin-bottom: 10px;
    }
}
</style>
